import queryString from 'query-string';
import { get } from 'lodash-es';

const urlParamsSelector = (state) => {
  const search = get(state.router, 'location.search');
  return search && queryString.parse(search);
};

export const urlSortSelector = (state) => get(urlParamsSelector(state), 'sort');
